<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>
          <v-toolbar color="grey" dark>
            <v-toolbar-title>Permisos
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn
                v-if="permisosList.findIndex(i => i.name === 'add_permisos') > -1"
                color="grey darken-2" dark class="mb-2" v-on="on">Nuevo</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field v-model.trim="editedItem.name" label="Nombre" :rules="notBlankRules">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox
                            v-if="editedIndex > -1"
                            v-model="activo"
                            label="Activo"
                            :value="activo"
                          ></v-checkbox>
                        </v-flex>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" dark @click.native="close">Cancelar</v-btn>
                          <v-btn v-if="editedIndex > -1" color="yellow darken-2" dark @click.native="editPermission(editedItem)" :disabled="loading" :loading="loading">Guardar</v-btn>
                          <v-btn v-else color="yellow darken-2" dark @click.native="addPermission(editedItem)" :disabled="loading" :loading="loading">Guardar</v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog><!-- end dialog edit o save-->
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="rolesList"
            item-key="user"
            class="elevation-1"
            light
            actions
            :loading="loading"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:item.activo="{ item }">
              <v-icon
                  v-if="!item.deleted_at"
                  class="mr-2"
                  color="green"
                >
                  mdi-check-bold
              </v-icon>
              <v-icon
                  v-else
                  class="mr-2"
                  color="grey"
                >
                  mdi-minus
              </v-icon>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon
                v-if="permisosList.findIndex(i => i.name === 'edit_permisos') > -1"
                color="orange"  class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon
                v-if="!item.deleted_at && permisosList.findIndex(i => i.name === 'delete_permisos') > -1"
                color="red"  @click="deleteRole(item)">mdi-close</v-icon>
              <!--<v-icon dark>mdi-folder-settings-variant</v-icon>-->
            </template>
          </v-data-table>
          <div class="text-center pt-2" v-if="rolesList.length > itemsPerPage">
            <v-pagination v-model="page" :length="pageCount"></v-pagination>
          </div>
        </v-card>
      </v-flex>
    </v-layout>

  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
const Swal = require('sweetalert2');
export default {

  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      changePassword:false,
      mask: '##########',
      celular: '',
      valid: true,
      dialog: false,
      loading:false, //component
      show: false,
      headers: [
        { text: 'Id', value: 'id', sortable: true },
        { text: 'Nombre', value: 'name', sortable: true },
        { text: 'Activo', value: 'activo', sortable: true },
        { text: 'Acciones', value: 'action' }
      ],
      rolesList: [],
      distritosList:[],
      editedIndex: -1,
      activo: true,
      editedItem: {
        name:'',
      },
      defaultItem: {
        name:'',
      },
      message: '',
      notBlankRules: [v => !!v || 'Este campo es requerido'],
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Permiso' : 'Editar Permiso'
    },
    ...mapGetters(["permisosList"])
  },
  mounted() {
    this.getPermisos();
  },
  // watch: {
  //   dialog (val) {
  //     val || this.close()
  //   }
  // },
  methods: {
    getPermisos() {
      this.$store.dispatch("GET_PERMISOS",  { url: "permissions" } ).then(response => {
          this.rolesList = response.data.data.permissions;//usar response para datos, se puede usar getters
        })
        .catch(err => {
          console.log(err);
        });
    },
    editItem (item) {
      this.editedIndex = this.rolesList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      if (this.editedItem.deleted_at) {
        this.activo = false
      }else {
        this.activo = true
      }
    },
    addPermission(){
      if (this.$refs.form.validate()) {
        this.loading = true;
        var data = this.editedItem;
        this.$store.dispatch("SAVE_PERMISO",  { url: "permission", data: data } ).then(response => {
          this.close ();
          Swal.fire({
            icon: 'success',
            title: 'Se Guardo Correctamente',
            confirmButtonText: "Aceptar"
          })
          this.getPermisos();
          //this.roles = response.data;//usar response para datos, se puede usar getters
        })
        .catch(error => {
          console.log(error);
          if(error.response.data.status){
            Swal.fire({
              icon: 'error',
              title: 'Error',
              title: error.response.data.status,
              confirmButtonText: "Aceptar"
            })
          }else{
            Swal.fire({
              icon: 'error',
              title: 'Error',
              title: 'Verifique los campos requeridos',
              confirmButtonText: "Aceptar"
            })
          }
        });
      }
      this.loading = false;
    },
    editPermission(item){
      this.dialog=false;
      item.activo = this.activo
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store.dispatch("EDIT_ROLE",  { url: "/permission/" + item.id, data: item } ).then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Rol actualizado correctamente.',
            confirmButtonText: "Aceptar"
          })
          this.getPermisos();
          //this.roles = response.data;//usar response para datos, se puede usar getters
        })
        .catch(err => {
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: err.response.data.status,
            confirmButtonText: "Aceptar"
          })
        });
        this.loading = false;
        this.close()
      }
    },
    deleteRole(item){
      this.$swal({
        title: '¿Desea eliminar Rol ' + item.name + '?',
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("DELETE_ROLE",  { url: "/permission/" + item.id } ).then(res => {
            Swal.fire({
              icon: 'success',
              title: 'Rol eliminado correctamente.',
              confirmButtonText: "Aceptar"
            })
            this.getPermisos();
          })
          .catch(err => {
            console.log(err);
          });
        }
      })
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.$refs.form.reset()
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.dialog = false
      }, 300)
    },
  }
}
</script>
